import axios from "axios";
import { useEffect, useState } from "react";
import API_ROUTES from "../constants/apis";
import { isUserLoggedIn } from "./utils";
import Logout from "../components/auth/Logout";

export function Links() {
  const [residencies, setResidencies] = useState([]);
  const [userData, setUserData] = useState(null);
  const loggedUser = isUserLoggedIn();

  const imageUrl = "https://res.cloudinary.com/ddtmsdlip/";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(API_ROUTES.USERS);
        const users = await response.json();

        const user = users.find(
          (userData) => loggedUser && userData.id === loggedUser.user_id
        );
        // const user = users.find(() => loggedUser && loggedUser.user_id);

        setUserData(user);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [loggedUser]);

  useEffect(() => {
    axios
      .get(`${API_ROUTES.HOSTEL}`)
      .then((response) => {
        setResidencies(response.data);
      })
      .catch((error) => {
        console.error("Error fetching residence details:", error);
      });
  }, []);

  return [
    {
      name: "Residencies",
      subMenu: true,
      subItems: residencies.map((residence) => ({
        name: residence.name,
        to: `/residencies/${residence.id}`,
      })),
    },
    { name: "Book Now", to: "/book" },
    { name: "Search", to: "/search" },
    { name: "Contact Us", to: "#contact" },
    ...(userData
      ? [
          {
            name: userData.image ? (
              <img
                src={imageUrl + userData.image}
                alt=""
                className="h-10 w-10 rounded-full"
              />
            ) : (
              userData.first_name || userData.email
            ),
          },
          { name: <Logout /> },
        ]
      : [
          {
            name: "Join Us",
            subMenu: true,
            subItems: [
              { name: "Register", to: "/register" },
              { name: "Login", to: "/login" },
            ],
          },
        ]),
  ];
}
